export default __webpack_public_path__ + "assets/images/cce6b3791e99b556e9bf9a91a8e96ddc.svg";